import React, { useState } from "react";

export interface SuppressSubscribersPanelProps {
  handleUnsubscribe: (email: string) => void;
  handleDelete: (email: string) => void;
}

const SuppressSubscribersPanel: React.FC<SuppressSubscribersPanelProps> = ({ handleUnsubscribe, handleDelete }) => {
  const [subscriberEmail, setSubscriberEmail] = useState("");

  const onUnsubscribe = () => {
    handleUnsubscribe(subscriberEmail);
    setSubscriberEmail("");
  };

  const onDelete = () => {
    const confirmed = window.confirm(
      "Are you sure you want to permanently delete this subscriber? This action cannot be undone."
    );
    if (confirmed) {
      handleDelete(subscriberEmail);
      setSubscriberEmail("");
    }
  };

  return (
      <div>
        <h1>Remove Subscriber</h1>

        <div style={{ display: "flex", flexDirection: "column", gap: "12px", width: "100%" }}>
          <label style={{ fontWeight: "600", fontSize: "16px" }}>Email:</label>
          <input
            type="email"
            value={subscriberEmail}
            onChange={(e) => setSubscriberEmail(e.target.value)}
            className="url-input"
            style={{ width: "100%" }}
          />
          <div style={{ display: "flex", gap: "12px", maxWidth: "400px" }}>
            <button
              className="primary-button"
              onClick={onUnsubscribe}
              style={{ flex: 1 }}
            >
              Unsubscribe
            </button>
            <button
              className="primary-button"
              onClick={onDelete}
              style={{
                flex: 1,
                backgroundColor: "#dc3545",
                border: "none",
              }}
            >
              Delete
            </button>
          </div>
        </div>
      </div>
  );
};

export default SuppressSubscribersPanel;
